export default {
  title: 'Parcels',
  new_parcel: 'New Parcel',
  edit_parcel: 'Edit Parcel',
  parcel_detail: 'Parcel Detail',

  labels: {
    tracking_number: 'Tracking Number',
    carrier: 'Carrier',
    description: 'Description',
    status: 'Status',
    property: 'Property',
    customer: 'Customer',
    recipient_name: 'Recipient Name',
    recipient: 'Recipient / Unit',
    unit: 'Unit',
    photos: 'Photos',
    received_at: 'Received',
    notified_at: 'Notified',
    collected_at: 'Collected',
  },

  status: {
    pending: 'Pending',
    notified: 'Notified',
    collected: 'Collected',
    needs_review: 'Needs review',
  },

  carriers: {
    thailand_post: 'Thailand Post',
    kerry_express: 'Kerry Express',
    flash_express: 'Flash Express',
    jt_express: 'J&T Express',
    shopee_express: 'Shopee Express',
    lazada_express: 'Lazada Express',
    other: 'Other',
  },

  actions: {
    notify_customer: 'Notify Customer',
    mark_collected: 'Mark Collected',
    assign_unit: 'Assign unit',
  },

  placeholders: {
    tracking_number: 'e.g., TH123456789',
    carrier: 'Select carrier',
    custom_carrier: 'Enter carrier name',
    description: 'Package description...',
    select_property: 'Select a property',
    select_customer: 'Select a customer',
    recipient_name: 'e.g. John Smith',
    select_unit: 'Select a unit',
  },

  messages: {
    created: 'Parcel registered',
    updated: 'Parcel updated',
    deleted: 'Parcel deleted',
    delete_confirm: 'Are you sure you want to delete this parcel?',
    notified: 'Customer notified',
    collected: 'Parcel marked as collected',
  },

  empty: {
    title: 'No parcels',
    description: 'Registered parcels will appear here.',
  },

  setup_guide: {
    title: 'Get Started with Parcel Tracking',
    description: 'Register and track parcels for your tenants.',
    prerequisites: {
      customers: 'At least 1 property with customers',
    },
    steps: {
      register: {
        title: 'Register a parcel',
        description: 'Log a received parcel with tracking info',
      },
      notify: {
        title: 'Notify customer',
        description: 'Let the tenant know their parcel arrived',
      },
      collect: {
        title: 'Mark collected',
        description: 'Record when the tenant picks up the parcel',
      },
    },
  },

  filters: {
    all: 'All',
    pending: 'Pending',
    notified: 'Notified',
    collected: 'Collected',
    needs_review: 'Needs review',
    date_from: 'From',
    date_to: 'To',
    search_placeholder: 'Search tracking number, recipient, unit, customer...',
  },

  timeline: {
    received: 'Received',
    notified: 'Customer Notified',
    collected: 'Collected by Customer',
  },

  extraction: {
    reading_unit: 'Reading unit...',
    unit_matched: 'Unit {{number}} detected',
    confirm_unit: 'Please confirm unit',
    no_match: 'Unit not detected',
    photo_hint: 'Tip: A clear photo of the address label helps automatically identify the unit.',
  },

  scan: {
    page_title: 'Quick Add Parcel',
    capture_prompt: 'Tap to photograph the address label',
    or_upload: 'or upload from library',
    quick_add: 'Quick add',
    photo_preview: 'Parcel photo',
  },

  errors: {
    validation_failed: 'Validation failed. Please check the form and try again.',

    fields: {
      property_id: 'Property',
      customer_id: 'Customer',
      unit_id: 'Unit',
      recipient_name: 'Recipient name',
      tracking_number: 'Tracking number',
      carrier: 'Carrier',
      received_at: 'Received date',
    },

    codes: {
      blank: "can't be blank",
      taken: 'is already taken',
      invalid: 'is invalid',
      too_short: 'is too short',
      too_long: 'is too long',
      inclusion: 'is not included in the list',
    },
  },
}
